








import { Component, Vue, Prop } from 'vue-property-decorator'
import * as util from '../../util'
@Component
export default class NoData extends Vue {
  @Prop() text
  back() {
    util.toCenterKnowledgeList()
  }
}
